// HeylpMate wordmark — matches uploaded brand logo: orange "Heylp" + green "Mate"
// Colours from brand system: Green (#00604A) + Orange (#F45118)
export default function Logo({ compact = false, tagline = false }) {
  return (
    <div className="inline-flex items-center gap-2 select-none">
      <div className="leading-none">
        <div className={`font-display font-black tracking-tight ${compact ? "text-lg" : "text-2xl md:text-3xl"}`}>
          <span style={{ color: "#F45118" }}>Heylp</span>
          <span style={{ color: "#00604A" }}>Mate</span>
          <sup className="text-[9px] md:text-[10px] align-super font-sans text-neutral-500 ml-0.5">™</sup>
        </div>
        {tagline && (
          <div className="text-[10px] tracking-[0.14em] mt-0.5" style={{ color: "#087A5A" }}>
            Real Human Assistance on Rent
          </div>
        )}
      </div>
    </div>
  );
}
